import { Show, createEffect, createMemo } from "solid-js";

import { Button } from "@/components/Base/Button/Button.tsx";
import { getImageAltByLang } from "@/constants/seo-constants.ts";
import { useCheckDomReady } from "@/hooks/useCheckDomReady.ts";
import { useRouter } from "@/hooks/useRouter.tsx";
import { getLocale, useI18n } from "@/i18n";
import BonusDropdownMenu from "@/layouts/pc/components/Header/BonusDropdownMenu.tsx";
import {
  getLocaleFromPath,
  getLocalizedPath,
  getRealPath,
} from "@/lib/language.ts";
import { getHeadImgurl, getImgurl } from "@/lib/resFolder.ts";
import { isGameRoute } from "@/lib/routeUtils.ts";
import { sdkManager } from "@/lib/sdk/sdkManager.ts";
import { cn } from "@/lib/utils.ts";
import { getWebsiteConfigV2 } from "@/stores/configStore.ts";
import { setProfileStore } from "@/stores/profileStore.ts";
import { userStore } from "@/stores/userStore.ts";

import HeaderWallet from "./HeaderWallet.tsx";

export default function HomeHeader(props: { isLandingPage?: boolean }) {
  const { push, pathname } = useRouter();
  const { t } = useI18n();

  const isDomReady = useCheckDomReady();

  const isLogin = createMemo(() => userStore.isLogin);

  const setPathName = () => {
    // 要考虑多语言的情况,有多语言时要存去掉多语言的路径
    const locale = getLocaleFromPath(pathname());
    const path = window.location.pathname;
    if (locale) {
      return path.replace(`/${locale}`, "");
    }
    return path;
  };

  const onReport = (key: string, data: Record<string, unknown>) => {
    sdkManager.tdReportEvent(key, {
      ...data,
    });
  };

  const fromPage = () => {
    return window.location.pathname;
  };
  return (
    <div class="bg-up-di flex h-full w-full items-center justify-between px-3 transition-colors duration-300 ease-in-out">
      {/* Logo */}
      <div class="flex items-center">
        {/* <Link href="/"> */}
        <img
          src={`/${__APP_NAME__}/images/logo/logo.png?v=${__APP_VERSION__}`}
          alt={getImageAltByLang("logo")}
          class="h-[29px] w-auto"
          onClick={() => {
            onReport("afun_homepage_click", {
              from_page: fromPage(),
            });
            push("/");
          }}
        />
        {/* </Link> */}
      </div>

      <Show when={!isLogin() && isDomReady()} fallback={<></>}>
        <div class="flex items-center gap-[10px]">
          {/* 奖金中心 */}
          <Show when={!props?.isLandingPage} fallback={<></>}>
            <BonusDropdownMenu />
          </Show>

          <Button
            variant="default"
            size="default"
            class="text-up-signin-zi min-w-[71px] px-[15px] text-[12px] font-[800] leading-[15px]"
            style={{ height: "35px", "border-radius": "5.25px" }}
            onClick={() => {
              onReport("signin_button_click", {
                from_page: fromPage(),
              });
              push("login");
            }}
          >
            {t("auth.sign_in")}
          </Button>
          <Button
            size="default"
            class="text-general-main bg-general-main10 relative min-w-[84px] px-[19px] text-[12px] font-[800] leading-[15px]"
            style={{ height: "35px", "border-radius": "5.25px" }}
            onClick={() => {
              onReport("signup_button_click", {
                from_page: fromPage(),
              });
              push("register");
            }}
          >
            {t("auth.sign_up")}
            {/* 游戏里面取消顶部状态栏的存款优惠图片提示 */}
            <Show
              when={
                getWebsiteConfigV2()?.registerRewardSwitch && !isGameRoute()
              }
              fallback={<></>}
            >
              <div class="absolute right-[12px] top-[35px]">
                <img
                  src={getImgurl(
                    `top-${getLocale()}.png`,
                    "common/home/deposit-act/locale",
                  )}
                  class={cn("shrink-0")}
                />
              </div>
            </Show>
          </Button>
        </div>
      </Show>

      <Show
        when={isLogin() && isDomReady() && !props?.isLandingPage}
        fallback={<></>}
      >
        <div class="flex gap-[6px]">
          <HeaderWallet />

          {/* 奖金中心 */}
          <BonusDropdownMenu />
          <div class="h-[34px] w-[34px] overflow-hidden rounded-[6px]">
            <img
              src={getHeadImgurl(Number(userStore.userInfo?.headimg))}
              alt="head"
              class="h-full w-full"
              onClick={() => {
                setProfileStore("from", setPathName());
                sdkManager.tdReportEvent("my_nav_click", {
                  source: fromPage(),
                });
                push("/profile");
              }}
            />
          </div>
        </div>
      </Show>
      <Show when={props?.isLandingPage && isLogin()} fallback={<></>}>
        <div
          id="user-dropdown-trigger"
          class="bg-general-icondi clickable border-up-stroke flex w-auto cursor-pointer items-center justify-center gap-[10px] rounded-[6px] border py-[2px] pl-[10px] pr-[2px]"
        >
          <div class="flex h-[31px] flex-col items-end">
            <span class="text-up-number1 h-4 text-xs font-medium">
              {userStore.userInfo?.nickname}
            </span>
            <span class="text-up-darkzi h-3 text-[10px] font-normal">
              ID:{userStore?.userInfo?.uid}
            </span>
          </div>
          <div class="size-[31px] overflow-hidden rounded-sm">
            <img
              src={getHeadImgurl(Number(userStore.userInfo?.headimg))}
              alt="head"
              class="h-full w-full"
            />
          </div>
        </div>
      </Show>
    </div>
  );
}
